import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import rfq from "../../images/Icons/rfq.png";
import arrow from "../../images/Icons/arrow-up.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchReceivedRfq } from "../../redux/slice/receivedRfq";
import config from "../../config";
import useLogout from "../Auth/useLogout";
import NoData from "../../Component/NoData";
import Dataloader from "../../Component/Dataloader";
import { hasPermission, canAccessRoute } from "../../utils/permissionUtils";
import { toast } from "react-toastify";

export default function ReceivedQuotationList() {
    const navigate = useNavigate();
    const user = config.user;
    const dispatch = useDispatch();
    const logout = useLogout();

    // Check if user has permission to access this page
    useEffect(() => {
        if (!canAccessRoute('quotation-list')) {
            navigate('/');
            toast.error('You do not have permission to access this page', {
                position: "top-right",
                autoClose: 3000,
            });
        }
    }, [navigate]);

    const { receivedRfqData, isError2 } = useSelector(
        (state) => state.receivedRfq
    );
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            if (!isError2) {
                setLoading(true);
                try {
                    await dispatch(fetchReceivedRfq(logout));
                } catch (err) {
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchData();
    }, [dispatch, isError2, logout]);

    const getFilteredData = () => {
        return receivedRfqData.map((item) => ({ ...item, type: "received" }));
    };

    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row-layout mrb1">
                        {loading ? (
                            <div className="d-flex justify-content-center">
                                <Dataloader />
                            </div>
                        ) : (
                            <>
                                <div className="row-hd-txt">
                                    <div className="row-hd-txt-left">
                                        <img src={rfq} alt="icon" />
                                        <h5>Received Quotations</h5>
                                    </div>
                                    {user && user.type === "seller" && (
                                        <div className="rfq-txt-right">
                                            <div className="btn-group" role="group">
                                                <Link
                                                    to="/quotation-list/received"
                                                    className="btn btn-sm btn-danger"
                                                >
                                                    Received
                                                </Link>
                                                <Link
                                                    to="/quotation-list/sent"
                                                    className="btn btn-sm btn-outline-danger"
                                                >
                                                    Sent
                                                </Link>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <p className="order-note">
                                    <span>Note - </span>
                                    For all your pending quotations, one of our relationship
                                    manager(RM) will reach out to assist you in fulfilling your
                                    requirements. In the mean time, please sit back and relax !
                                </p>
                                {getFilteredData().length > 0 ? (
                                    <div className="row g-3">
                                        {getFilteredData().map((item, index) => {
                                            // Check permissions for view access
                                            const canViewQuotation = hasPermission('quotation', 'view');

                                            return (
                                                <div className="col-lg-4 col-md-6 px-2" key={index}>
                                                    {canViewQuotation ? (
                                                        <Link
                                                            to={`/seller-quotation-detail/${item.id}`}
                                                        >
                                                            <div className="rfq-content">
                                                                <div className="d-flex flex-row align-items-center">
                                                                    <div className="left">
                                                                        <img
                                                                            src={arrow}
                                                                            alt=""
                                                                            className="img in"
                                                                        />
                                                                    </div>
                                                                    <div className="right">
                                                                        <span>Quotation No: {item.unique_id}</span>
                                                                        <div className="row">
                                                                            <div className="col-lg-12">
                                                                                <p>
                                                                                    Quotation received for {item.commodity_product.name}
                                                                                </p>
                                                                            </div>
                                                                            <div className="col-lg-12 text-dark">
                                                                                {item.created_at}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="status">
                                                                    <span>{item.status}</span>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    ) : (
                                                        <div className="rfq-content disabled-content">
                                                            <div className="d-flex flex-row align-items-center">
                                                                <div className="left">
                                                                    <img
                                                                        src={arrow}
                                                                        alt=""
                                                                        className="img in"
                                                                    />
                                                                </div>
                                                                <div className="right">
                                                                    <span>Quotation No: {item.unique_id}</span>
                                                                    <div className="row">
                                                                        <div className="col-lg-12">
                                                                            <p>
                                                                                Quotation received for {item.commodity_product.name}
                                                                            </p>
                                                                        </div>
                                                                        <div className="col-lg-12 text-dark">
                                                                            {item.created_at}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="status">
                                                                <span>{item.status}</span>
                                                            </div>
                                                            <div className="permission-overlay">
                                                                <small>No permission to view</small>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <NoData />
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
